import {css, useTheme} from '@mui/material';
import {ConfigObjectType, GetStylesFunction, utils} from '@wallaby-ui/core';
import * as React from 'react';
import {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {useStore} from 'react-redux';

import FilterAndSearchContainer from 'src/js/containers/filter_and_search/components/FilterAndSearchContainer';
import {FILTER_AND_SEARCH_REDUCER_STATE_ID} from 'src/js/containers/filter_and_search/filter_and_search_constants';
import {FILTERING_REDUCER_STATE_ID} from 'src/js/containers/filtering/filtering_constants';
import {
  TIMELINE_FEATURE_NAME,
  HOSPITALIZATIONS_SEARCH_COMPONENTS,
} from 'src/js/containers/hospitalizations/hospitalizations_constants';
import {dataTransformFunction} from 'src/js/containers/hospitalizations/hospitalizations_helpers';
import {MUIListWrapperContainer} from 'src/js/containers/list/components/MUIListWrapperContainer';
import {LIST_REDUCER_STATE_ID} from 'src/js/containers/list/list_constants';

const LIST_REDUCER_STATE_ID_TIMELINE = utils.reducerUtils.getInstanceReducerId(
  LIST_REDUCER_STATE_ID,
  TIMELINE_FEATURE_NAME
);
const FILTER_AND_SEARCH_REDUCER_STATE_ID_TIMELINE =
  utils.reducerUtils.getInstanceReducerId(
    FILTER_AND_SEARCH_REDUCER_STATE_ID,
    TIMELINE_FEATURE_NAME
  );

const FILTERING_REDUCER_STATE_ID_TIMELINE =
  utils.reducerUtils.getInstanceReducerId(
    FILTERING_REDUCER_STATE_ID,
    TIMELINE_FEATURE_NAME
  );

interface OwnProps {
  config: ConfigObjectType;
}

type Props = OwnProps;

export const HospitalizationTimeline: React.FC<Props> = (props) => {
  const {timelineData, config, route} = props;
  const theme = useTheme();
  const styles = getStyles({theme});
  const store = useStore();
  const state = store && store.getState();
  const intl = useIntl();

  // TODO-JK: add correct searchService url when BE is available
  const serviceUrls = useMemo(
    () => ({
      searchService: config.service.url.coreEnums,
      searchDetailRoute: '',
      listRoute: route,
      tablesConfigIds: [],
      gridConfigConfigPath: `feature.hospitalizationsDetail.timeline.grid`,
      userFilterType: `_wallaby_documents`,
      list: 'TimelineGrid',
      // filtersConfigPath: 'feature.hospitalizationsDetail.list.filters',
    }),
    [config.service.url.coreEnums, route]
  );

  return (
    <>
      <MUIListWrapperContainer
        listStateId={LIST_REDUCER_STATE_ID_TIMELINE}
        config={config}
        gridId={serviceUrls.gridConfigConfigPath}
        serviceUrls={serviceUrls}
        filterAndSearchStateId={FILTER_AND_SEARCH_REDUCER_STATE_ID_TIMELINE}
        exportDisabled
        showPageSize={false}
        dataTransformFunction={dataTransformFunction}
        featureName={TIMELINE_FEATURE_NAME}
      />
      <FilterAndSearchContainer
        filterAndSearchStateId={FILTER_AND_SEARCH_REDUCER_STATE_ID_TIMELINE}
        config={config}
        searchComponents={HOSPITALIZATIONS_SEARCH_COMPONENTS}
        searchServiceUrl={serviceUrls.searchService}
        serviceUrls={serviceUrls}
        dynamicResultItems={serviceUrls.dynamicResultItems}
        featureName={TIMELINE_FEATURE_NAME}
      />
    </>
  );
};

HospitalizationTimeline.displayName = 'HospitalizationTimeline';

const getStyles: GetStylesFunction = (options) => ({
  contentWrapper: css`
    display: flex;
    flex-direction: row;
    gap: ${options?.theme?.spacing(3)};
    align-items: center;
  `,
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${options?.theme?.spacing(2.5)};
  `,
  riskFactorType: css`
    color: ${options?.theme?.palette.custom.coolGray['800']};
    text-decoration: underline;
  `,
  riskFactorLabel: css`
    color: ${options?.theme?.palette.custom.coolGray['900']};
  `,
});
